import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FontService } from 'src/app/shared/font-service/font.service';
import { LimitTransListService } from '../../limit-translist/limit-translist.service';
import { HttpResponse } from '@angular/common/http';
import { FinYear } from '../../limit-translist/limit-translist.module';
import { Location } from '@angular/common';
import { ProjectService } from 'src/app/project/project.service';
import { NotificationService } from 'src/app/alert/notification.service';
import { ConfirmationService} from 'primeng/api';
@Component({
  selector: 'app-limit-allocation',
  templateUrl: './limit-allocation.component.html',
  styleUrls: ['./limit-allocation.component.scss']
})
export class LimitAllocationComponent implements OnInit {
  limitAllocationDialog:boolean=false;
  limitcorrectionDialog:boolean=false;
  currentPath: any;
  finYearValue:any;
  agencyValue:any;
  fromProjectValue:any;
  toProjectValue:any;
  projectFiltervalue:any;
  agencyFiltervalue:any;
  govermentTypeFiltervalue:any;
  toProjectList:any=[];
  toProjectAllocatedAmount:any;
  ngSelectInvalid: boolean = false;
  govermentType = [
    {
      name: 'CENTRAL_GOVERNMENT',
    },
    {
      name: 'STATE_GOVERNMENT',
    },]
    categoryList = [
 {
        name: 'Project',
      }];
      agencyList:any =[];
      projectList:any =[];
      categoryData:any;
  finYear: HttpResponse<FinYear[]>;
  isType: boolean =false;
  isProject: boolean =false;
  heading: string;
  fromProjectAmount: any;
  fromProject: any;
  toProjectAmount: any;
  projectListFilter: any;
  itemsPerPage: any =10;
  page: any;
  projectData: any;
  isTable: boolean =false;
  pageCount: number;
  pageLength: number;
  totalCount: any;
  constructor( public fontService: FontService,  private cdr: ChangeDetectorRef, private limitTransListService: LimitTransListService, private location: Location,  private projectService: ProjectService,
    private notificationService:NotificationService,    private confirmationService: ConfirmationService,) {
    this.currentPath = this.location.path();
   }

  ngOnInit(): void {
   
    this.loadPage(1)
    //this.getProjects();
console.log(this.currentPath)
    if(this.currentPath=='/limit-allocation'){
      console.log(this.currentPath)
this.heading='Budget Allocation'
    }else{
      this.heading='Budget Correction'
    }
    this.cdr.detectChanges();
  }
  openNew(){
    if(this.currentPath=='/limit-allocation'){
      this.limitAllocationDialog=true
      this.getFinyear();
    }else{
    this.limitcorrectionDialog=true
  }

  }
  hideDialog(){
this.limitAllocationDialog=false;
this.agencyValue=null;
this.fromProjectValue=null;
this.toProjectValue=null;
this.fromProjectAmount=null;
this.toProjectAmount=null;
this.toProjectAllocatedAmount=null;
this.agencyList=null;
this.projectList=null;
  }

  onChangeCategory(data){
// console.log(data)
// if(data.name=='Req.Agency'){
//   this.isType=true;
// }else if(data.name=='Project'){
// this.isType=true;
// this.isProject=true;
// }else{
//   this.isType=false;
// this.isProject=false;
// }

  }
  approveRecord(data,event){



    console.log(data,event)
    if(event=='approve'){
      this.confirmationService.confirm({
        message: 'Are you sure that you want to approve?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.limitTransListService.approveProject(data.id).subscribe(res=>{
            this.notificationService.alertSuccess('Approved Successfully','')
          this.loadPage(0)
          },(err=>{
            if(err.status==400){
              this.notificationService.alertError(err.error,'')
            }else{
              this.notificationService.alertError('Something went wrong please try agian after sometime','')
            }
          }))
        },
      });

    }else if(event=='reject'){
      this.confirmationService.confirm({
        message: 'Are you sure that you want to reject?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.limitTransListService.rejectProject(data.id).subscribe(res=>{
            this.notificationService.alertSuccess('Rejected Successfully','')
            this.loadPage(0)
          },(err=>{
            if(err.status==400){
              this.notificationService.alertError(err.error,'')
            }else{
              this.notificationService.alertError('Something went wrong please try agian after sometime','')
            }
           
          }))
        },
      });

    }
  }

  getFinyear(){
    this.agencyValue=null;
    this.fromProjectValue=null;
    this.toProjectValue=null;
    this.fromProjectAmount=null;
    this.toProjectAmount=null;
    this.toProjectAllocatedAmount=null;
    this.agencyList=null;
    this.projectList=null;
    this.limitTransListService.getFinYear().subscribe(
      (res: HttpResponse<any>) => {
        console.log(res)
        this.finYear = res.body;
      },
      () => { }
    );
    this.categoryData=this.categoryList[0].name
  }
  getAgency(event){
  console.log(event)
  this.fromProjectValue=null;
  this.toProjectValue=null;
  this.fromProjectAmount=null;
  this.toProjectAmount=null;
  this.toProjectAllocatedAmount=null;
    this.limitTransListService.getAgencyList(event.name).subscribe(res=>{
this.agencyList=res.body
    },      (err) => {
      this.notificationService.alertError(err.error,'')

    })
  }
  
  getProject(event){
    console.log(event)
    this.fromProjectValue=null;
    this.toProjectValue=null;
    this.fromProjectAmount=null;
    this.toProjectAmount=null;
    this.toProjectAllocatedAmount=null;
      this.limitTransListService.getProjectList(event.id).subscribe(res=>{
        console.log(res)
  this.projectList=res.body;
  console.log(this.projectList)
      },      (err) => {
        this.notificationService.alertError(err.error,'')
    
      })
    }
    fromProjectChange(event){
      this.toProjectValue=null;
      this.fromProjectAmount=null;
      this.toProjectAmount=null;
      this.toProjectAllocatedAmount=null;
     
      this.fromProject=event
      this.fromProjectAmount=event.amount;
      this.getToProjectList();

    }
    getToProjectList(){
      console.log(this.projectList);
      console.log(this.fromProject)
     this.toProjectList = this.projectList.filter(
        project => project.id !== this.fromProject.id
      );
    }
    toProjectChange(event){
      this.toProjectAmount=null;
      this.toProjectAllocatedAmount=null;
      this.toProjectAmount=event.amount;
    }
    filterpage(){
if(!this.govermentTypeFiltervalue && !this.agencyFiltervalue && !this.projectFiltervalue){
  this.notificationService.alertError('Please select all the fields marked with *','')
  return
}else{
  this.limitTransListService.getProjectfilter(this.projectFiltervalue).subscribe(res=>{
    console.log(res)
  })
}

    }
    loadPage(page?:any){
      const pageToLoad: number = page ?? this.page ?? 1;
      let query = {
        page: pageToLoad - 1,
        size: this.itemsPerPage,
      };
      console.log(query)
this.limitTransListService.getProjectfilterList({ ...query }).subscribe(res=>{
  console.log(res)
  this.isTable=true
  this.projectData=res.body.content
  this.totalCount=res.body.totalElements
})
    }

  onPageChange(event: any) {
    this.itemsPerPage = event.rows;
    this.pageCount = Number(event.page);
    let page = Number(event.page) + 1;
    this.pageLength = Number(event.page)
    this.loadPage(page);
  }

  getProjects() {
    this.projectService.getProjectList().subscribe(
      (res: any) => {

        this.projectListFilter = res.body.data;

      },
      (err) => {
        this.notificationService.alertError(err.error,'')
        // this.onError();
      }
    );
  }

  saveLimit(){

    const isFormValid =
    this.finYearValue &&
    this.agencyValue &&
    this.fromProjectValue &&
    this.toProjectValue &&
    this.toProjectAllocatedAmount

    if (!isFormValid) {
      this.ngSelectInvalid = true;
      this.notificationService.alertError("Please fill all the mandatory fields", '')
      return;
    }

  let data= {
     
      finYearId: this.finYearValue.id,
      category: 'project',
      agencyId: this.agencyValue.id,
      fromProjectId: this.fromProjectValue.id,
      toProjectId: this.toProjectValue.id,
      amount: this.toProjectAllocatedAmount,
    }
    this.limitTransListService.saveProject(data).subscribe(res=>{
      this.notificationService.alertSuccess('Allocation Added Successfully','')
    this.hideDialog();
    this.loadPage(1)

    },(err=>{
      this.notificationService.alertError(err.error,'')
    }))
  }
}
